<template>
    <div>
        <timeline :time-line-items="steps" :active-index="1">
            <template v-slot:form>
                <Card>
                    <div class="row">
                        <div class="col-8 mb-6">
                            <div class="checkbox-inline">
                                <label class="checkbox checkbox-primary">
                                    <input type="checkbox"
                                           @click="toggleDisableMultipleAddons('myself')"
                                           v-model="form.addons.myself"
                                    >
                                    <span></span>{{ __('account-setup.onboard_myself')}}
                                </label>
                            </div>
                        </div>
                        <div class="col-2 text-lg">{{ __('account-setup.free') }}</div>
                    </div>
                    <div class="row">
                        <div class="col-8">
                            <div class="checkbox-inline">
                                <label class="checkbox checkbox-primary">
                                    <input type="checkbox"
                                           @click="toggleDisableMultipleAddons('agency')"
                                           v-model="form.addons.agency"
                                    >
                                    <span></span>{{ __('account-setup.onboard_agency') }}
                                </label>
                            </div>
                        </div>
                        <div class="col-2 text-lg">{{ __('account-setup.free') }}</div>
                    </div>
                    <span class="invalid-feedback d-inline" v-if="form.errors.addons">
                            {{ form.errors.addons }}
                        </span>
                </Card>

                <div class="text-center my-8 font-weight-bold text-xl font-italic text-uppercase">{{ __('general.or') }}</div>

                <Card>
                    <div v-for="addon in getGroupOneAddons" class="row">
                        <div class="col-8">
                            <div class="checkbox-inline">
                                <label class="checkbox checkbox-primary">
                                    <input type="checkbox"
                                           @click="toggleDisableMultipleAddons(addon.id)"
                                           v-model="form.addons[addon.id]">
                                    <span></span>{{ getTranslation(addon.lang.name) }}
                                </label>
                            </div>
                            <div class="text-muted">{{ getTranslation(addon.lang.description) }}</div>
                        </div>
                        <div class="col-2 text-xl font-weight-bold">
                            <Price :value="addon.pricing_groups.all[0].value" :currency="addon.pricing_groups.all[0].currency"></Price>
                        </div>
                        <div class="col-2 text-lg">
                            {{ __(`account-setup.${addon.pricing_groups.all[0].invoicing_type}`) }}
                        </div>
                    </div>
                </Card>

                <div class="text-center my-8 font-weight-bold text-xl font-italic text-uppercase">{{ __('general.or') }}</div>

                <Card>
                    <div v-for="addon in getGroupTwoAddons" class="row mb-6">
                        <div class="col-8">
                            <div class="checkbox-inline">
                                <label class="checkbox checkbox-primary"
                                       :class="multipleAddonsDisabled ? 'checkbox-disabled' : ''">
                                    <input type="checkbox"
                                           v-model="form.addons[addon.id]"
                                           :disabled="multipleAddonsDisabled"
                                    >
                                    <span></span>{{ getTranslation(addon.lang.name) }}
                                </label>
                            </div>
                            <div class="text-muted ml-9">{{ getTranslation(addon.lang.description) }}</div>
                            <div class="text-muted ml-9">{{ getTranslation(addon.lang.onboarding_time) }}</div>
                            <div v-if="addon.is_amazon_only" class="ml-9 text-muted font-italic">{{ __('account-setup.amazon_only') }}
                            </div>
                            <div v-else-if="addon.is_google_only" class="ml-9 text-muted font-italic">{{ __('account-setup.google_only') }}
                            </div>
                        </div>
                        <Price :value="addon.pricing_groups.all[0].value" :currency="addon.pricing_groups.all[0].currency" class="col-2 text-lg"></Price>
                        <div class="col-2 text-lg">{{
                                __(`account-setup.${addon.pricing_groups.all[0].invoicing_type}`)
                            }}
                        </div>
                    </div>
                </Card>

                <div class="d-flex justify-content-end mt-12">
                    <button @click="previousStep" class="mr-auto py-4 btn btn-secondary">
                        <i class="fas fa-arrow-circle-left mr-3"></i>{{ __('actions.back') }}
                    </button>
                    <button @click="submit()" class="btn btn-primary">
                        {{ __('actions.next') }}<i class="fas fa-arrow-circle-right ml-3"></i>
                    </button>
                </div>

            </template>
        </timeline>
    </div>
</template>

<script>
import Timeline from '@components/Timeline';
import AccountSetupLayout from '@layouts/AccountSetupLayout';
import Price from '@components/Price';
import Card from '@components/Cards/Card';
import Badge from '@components/Badge';
import Checkbox from "@components/Form/Checkbox.vue";
import helperMethods from '@mixins/helperMethods'

export default {
    name: 'Addons',
    mixins: [helperMethods],
    components: {Checkbox, Badge, Card, Price, Timeline},
    layout: AccountSetupLayout,
    props: {
        addons: Object,
        steps: Object,
        savedFeatures: Array | Object,
        savedAddons: Object,
    },

    data() {
        return {
            form: this.$inertia.form({
                addons: {},
            }),
            multipleAddonsDisabled: false,
        };
    },

    mounted() {
        Object.values(this.addons).forEach(addon => {
            this.$set(this.form.addons, addon.id, false);
        });

        if (this.savedAddons && Object.keys(this.savedAddons).length > 0) {
            Object.assign(this.form.addons, this.savedAddons);

            if ((this.savedAddons.hasOwnProperty(1) && this.savedAddons[1] === true) ||
                (this.savedAddons.hasOwnProperty('myself') && this.savedAddons.myself === true) ||
                (this.savedAddons.hasOwnProperty('agency') && this.savedAddons.agency === true)) {
                this.multipleAddonsDisabled = true;
            }
        }
    },

    computed: {
        getGroupOneAddons() {
            return Object.values(this.addons).filter(addon => {
                return addon.group === 1;
            })
        },

        getGroupTwoAddons() {
            return Object.values(this.addons).filter(addon => {
                return addon.group === 2;
            })
        },
    },

    methods: {
        toggleDisableMultipleAddons(field) {
            if (this.form.addons[field] === true) {
                this.multipleAddonsDisabled = false;

                return;
            }
            this.form.reset('addons');
            this.$set(this.form.addons, field, true);
            this.multipleAddonsDisabled = true;
        },

        previousStep() {
            this.$inertia.get(this.$route('account-setup-features.show'));
        },

        submit() {
            this.form.post(this.$route('account-setup-addons.update'), {
                preserveState: true,
                preserveScroll: true,
                onError: () => {
                    toastr.error(__('general.error_check_data'))
                },
                onSuccess:() => {
                    toastr.success(__('account-setup.thing.success', {thing: __('subscriptions.addons')}))
                }
            });
        },
    },
};
</script>
